import { useContext } from 'react';

import { WhiteLabelContext } from '../contexts/WhiteLabelContext';

export default () => useContext(WhiteLabelContext);
